var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-caption text--secondary"},[_vm._v("\n    "+_vm._s(_vm.$t('for'))+"\n    "+_vm._s(_vm.touristsTotal)+" "+_vm._s(_vm.$tc(_vm.touristLabel, _vm.touristsTotal))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }